import {
  NextInvoiceDate,
  NextInvoiceTitle,
  NextInvoiceWrapper
} from '@anm/components/subscription/current-plan/NextInvoiceBlock/Wrapper';
import formatSubscriptionDate from '@anm/helpers/subscription/formatSubscriptionDate';
import { FC } from 'react';

type NextInvoiceBlockProps = { date: string; amount: string };

const NextInvoiceBlock: FC<NextInvoiceBlockProps> = ({ date, amount }) => {
  return (
    <NextInvoiceWrapper>
      <NextInvoiceTitle>Next payment</NextInvoiceTitle>
      <NextInvoiceDate>
        ${amount} on&nbsp;
        {formatSubscriptionDate(date, {
          isHours: false
        })}
      </NextInvoiceDate>
    </NextInvoiceWrapper>
  );
};
export default NextInvoiceBlock;
